import { required } from 'vee-validate/dist/rules';

export const termsAndConditionsValidator = {
    ...required,
    message(field: string) {
        return 'You need to read and accept the terms and conditions before proceeding';
    },
};
